import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { addressI } from 'app/core/interfaces/adress';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { IdentifierAPIResponse } from 'app/core/interfaces/identifier';
import Practitionerrole from 'app/core/models/Practitionerrole';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';

@Component({
  selector: 'page-practitioner-secretary-details',
  templateUrl: './practitioner-details.component.html',
  styleUrls: ['./practitioner-details.component.scss']
})
export class PractionerSecretaryDetailsComponent extends BaseComponent implements OnInit {

  public practitioner: any|undefined = <any>{};
  public mock:practitionerI[] = [];
  public address:addressI = <addressI>{};
  public titles = ['Qualificações', 'Cursos/Certificados', 'Idiomas'];
  public active = true;

  public practitionerRole: any



  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private practitionerRoleService: PractitionerroleService
  ) {
    super(injector);
   }
   

  ngOnInit(): void {


    if (this.data.param?.practioner){

      this.practitioner = this.data.param?.practioner
      this.getPractitionerSpecialties()

      this.practitioner.crm  = this.extractIdentifiers(this.practitioner.identifier).CRM


      this.address = this.formatAddress(this.practitioner.address[0]) ?? {}
      const qualifications = this.transformarQualifications( this.practitioner?.qualification)
     
      this.practitioner.qualifications = qualifications.qualificacoes
      this.practitioner.certificates = qualifications.certificados

    }

  }

  private extractIdentifiers(identifiers: IdentifierAPIResponse[]){

    let CPF: string | null = null;
    let CRM: string | null = null;
    let CNPJ: string | null = null;

    identifiers.forEach(identifier => {
        const { system, value } = identifier;

        if (system === "CPF") {
          CPF = value;
        } else if (system === "CRM") {
          CRM = value;
        }else if (system === "CNPJ") {
          CNPJ = value;
        }

    });

    return { CPF, CRM, CNPJ };

  }

  private getPractitionerSpecialties() {
   
    const practitioner_id = this.practitioner.practitioner_id

    this.practitionerRoleService.findPractitionerByPractitionerroleId(practitioner_id).subscribe({
      next: (practitionerrole: Practitionerrole[]) => {
        this.practitionerRole = practitionerrole[0]
        this.practitionerRole.specialtys = practitionerrole[0].specialty
      },
      error: (err) => {
        console.log(err); // Posteriormente, adicionar um toastr aqui
       
      },
    });
  }


  formatAddress(address : any ) {

    const extraInfos = address?.line ?? [];

    return {
      cep: address.postalCode,
      city: address.city,
      country: address.country,
      state: address.state,
      street: extraInfos[0] ?? '',
      number: extraInfos[1] ?? '',
      complement: extraInfos[2] ?? '',

    }
  }

  transformarQualifications(qualifications: any) {
    const qualificacoes: any[] = [];
    const certificados: any[] = [];
  
    qualifications.forEach( (qualification: any) => {
      const tipo = qualification.code.type;
      const dadosTransformados = {
        id: 1, // Defina a lógica para gerar o id, se necessário
        name: qualification.identifier[0].value,
        instituition: qualification.issuer.display,
        dateConclusion: qualification.period.end,
        type: tipo
      };
  
      if (tipo === 'QUALIFICATION') {
        qualificacoes.push(dadosTransformados);
      } else if (tipo === 'COURSE') {
        certificados.push(dadosTransformados);
      }
    });
  
    return { qualificacoes, certificados };
  }
  
  // Função para transformar o campo communication
  transformarCommunication(communication: any) {
    return communication.map( (com: any) => ({
      languageHL7: com.language
    }));
  }

}
